import Ractive from 'ractive';
import { createReactAdapter, createReactDecoratorAdapter } from './RactiveAdaptor';
import { Button } from './elements/Button/Button';
import { SecretField } from './elements/SecretField/SecretField';
import { Checkbox } from './elements/Checkbox/Checkbox';
import { Stack } from './elements/Stack/Stack';
import { Typography } from './elements/Typography/Typography';
import { Combobox } from './elements/Combobox/Combobox';
import { SideToggle } from './elements/SideToggle/SideToggle';
import { ContextMenuHost } from './elements/ContextMenu/ContextMenuHost';
import { TimeNumeric } from './elements/Numerics/TimeNumeric/TimeNumeric';
import { TooltipDecorator } from './elements/Tooltip/TooltipDecorator';
import { TooltipHover } from './elements/Tooltip/TooltipHover';
import { TooltipClick } from './elements/Tooltip/TooltipClick';
import { TooltipError } from './elements/Tooltip/TooltipError';
import { FormLabel } from './elements/FormLabel/FormLabel';
import { TradingNumeric } from './elements/Numerics/TradingNumerics/TradingNumeric/TradingNumeric';
import { SLTPNumeric } from './elements/Numerics/TradingNumerics/SLTPNumeric/SLTPNumeric';
import { Link } from './elements/Link/Link';
import { UpdateNotificationScreen } from './screens/UpdateNotificationScreen/UpdateNotificationScreen';
import { WebhooksCodeSnippet } from './screens/WebhooksScreen/elements/WebhooksCodeSnippet';
Ractive.components.reactStack = createReactDecoratorAdapter(Stack);
Ractive.components.reactTypography = createReactDecoratorAdapter(Typography);
Ractive.components.reactTooltipDecorator = createReactDecoratorAdapter(TooltipDecorator);
Ractive.components.reactFormLabel = createReactDecoratorAdapter(FormLabel);
Ractive.components.reactTooltipHover = createReactAdapter(TooltipHover);
Ractive.components.reactTooltipClick = createReactAdapter(TooltipClick);
Ractive.components.reactTooltipError = createReactAdapter(TooltipError);
Ractive.components.reactButton = createReactAdapter(Button);
Ractive.components.reactSecretField = createReactAdapter(SecretField);
Ractive.components.reactCheckbox = createReactAdapter(Checkbox);
Ractive.components.reactCombobox = createReactAdapter(Combobox);
Ractive.components.reactSideToggle = createReactAdapter(SideToggle);
Ractive.components.reactContextMenuInstance = createReactAdapter(ContextMenuHost);
Ractive.components.reactTimeNumeric = createReactAdapter(TimeNumeric);
Ractive.components.reactTradingNumeric = createReactAdapter(TradingNumeric);
Ractive.components.reactSLTPNumeric = createReactAdapter(SLTPNumeric);
Ractive.components.reactLink = createReactAdapter(Link);
//#region Screens
Ractive.components.reactUpdateNotificationScreen = createReactAdapter(UpdateNotificationScreen);
//#region Webhooks screen
Ractive.components.reactWebhooksCodeSnippet = createReactAdapter(WebhooksCodeSnippet);
//#endregion
//#endregion
